<template>
	<div>
		<Header />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/notice/banner.jpg?2`" />
			<cloud />
		</div>
		<div class="TabWrap">
			<div @click="link2Route(item)" :class="{on:((routeName=='notice'||routeName=='noticeIndex'||routeName=='noticeList')&&item.id === 3) || (item.id===6 && routeName=='coList')}" v-for="(item,index) in channelList" :key="index">{{item.name}}</div>
			<div @click="link2Stock" :class="{on:routeName=='stock'}">{{ $t('aside.stock') }}</div>
		</div>
		<div class="notice-content">
			<router-view :key="$route.path" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
            	channelList:[]
			}
		},
		mounted() {
        	this.getChannelList();
		},
		computed:{
			routeName: function(){
           		return this.$route.name
			}
		},
		methods: {
			getChannelList(){
				this.$api.getChannelList({lang:localStorage.getItem('language') || 'zh-cn'}).then(res=>{
					if(!res.code){
						this.channelList = res.data;
						return false
					}
					this.$util.$error(res.message)
				})
			},
			link2Stock(){
				 this.$router.push('/stock');
			},
			link2Route(data){
				if(data.id===3){
					this.$router.push(`/notice/index`);
				}
				if(data.id===6){
					this.$router.push(`/co/7`);
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	.bannerWrap{
		position: relative;
		width: 100%;
		.bannerImg {
			width: 100%;
		}
	}
	.TabWrap {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 100%;
		height: 0.88rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 5px 0px rgba(22, 26, 26, 0.1);
		margin-top: 0.26rem;
		>div {
			display: flex;
			align-items: center;
			max-width: 1.4rem;
			height: 100%;
			padding-top: 0.14rem;
			text-align: center;
			font-size: 0.26rem;
			color: #999999;
			box-sizing: border-box;
			line-height: 0.26rem;
			&.on {
				color: #161A1A;
				font-weight: bold;
				border-bottom: 0.06rem solid #161A1A;
			}
		}
	}
	.notice-content{
		padding: 0 0.82rem;
		box-sizing: border-box;
	}
</style>


// WEBPACK FOOTER //
// src/views/notice/index.vue